module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/tUtK0X/tc-custom/9781634868747.jpg?1718072539736",
      "alt": "This image is the cover for the book Controlled, Hot Flash"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Controlled, Hot Flash\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("He likes to think he’s in control. He always wants to be “in charge.” Which is fine by me. That’s what I want him to think."), _c('br'), _c('br'), _vm._v("Whenever life threatens to get in between us, when he’s so busy at work that he’s too tired to love me in the evenings, I know I have to take matters into my own hands."), _c('br'), _c('br'), _vm._v("But I have to be discreet. I want him, but I can’t let him know how much. I want him to want "), _c('i', [_vm._v("me")]), _vm._v("."), _c('br'), _c('br'), _vm._v("And I always get what I want. So which of us is really in control?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      J.M. Snyder\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0